import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubscriptionListComponent } from './subscription-list/subscription-list.component';
import { AuthGuardService } from '@app/extra-module/auth-intercept/auth-guard.service';
import { MainLayoutComponent } from '@app/shared-module/main-layout/main-layout.component';
import { DoctorLeadComponent } from './doctor-lead/doctor-lead.component';


const routes: Routes = [
  {
    path: 'doctor', component: MainLayoutComponent,
    children: [
      { path: 'lead', component: DoctorLeadComponent, data: { title: 'Doctor Lead' } },
      { path: 'subscription', component: SubscriptionListComponent, data: { title: 'Subscription' } },
      { path: '', redirectTo: 'lead', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DoctorRoutingModule { }
